// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"7c7a40a0","141":"5e5b83f1","732":"bf2e5f62"}[chunkId] + ".css";
};